import React from "react";

export default function handleEnterKeyPress(e: React.KeyboardEvent, isFormValid: boolean, isLoading: boolean, keyPressAction : () => void): void {
  if (e.key === "Enter" && !e.shiftKey && isFormValid && !isLoading) {
    e.preventDefault()
    keyPressAction();
  }
}
